import React, { useState} from 'react'
import {connect} from 'react-redux'
import { validateDocument } from '../../redux/validate-document/validate-document.actions'

import  {FileDropzone} from './dropzone/dropzone.component';
import { SelectedDocument } from './selectedDocument/selected-document.component'

const FormComponent= (props) => {

  const [currentFile, setCurrentFile] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const onFormSubmit =  async (e) => {
    e.preventDefault();
    if(!currentFile) {
      setErrorMessage('Niste odabrali dokument')
      return;
    }  
    
    const { base64Document, name } = currentFile
    props.validateDocument({base64Document, fileName: name})
  }

  const diplayError = () => {
    return (
      <div className="error-message">
        <p>{errorMessage}</p>
      </div>
    )
  }

    return (
      <div>
        <h2>Za detaljan prikaz informacija o potpisu, priložite dokument</h2>
      
        <form onSubmit={onFormSubmit}>       
          <div>
          { 
              currentFile 
              ? <SelectedDocument setCurrentFile={setCurrentFile} currentFile={currentFile} />
              :  <FileDropzone setCurrentFile={setCurrentFile} setErrorMessage={setErrorMessage}  />
            }
            
            {errorMessage && diplayError()}
              <input 
                className="form-button" 
                type="submit" 
                value="Nastavi"
              />
          </div>
        </form>
       </div>
    )

}

const mapDispatchToProps = dispatch => ({
  validateDocument: base64Document => dispatch(validateDocument(base64Document)),
  //fetchUserAsync: () => dispatch(fetchUserAsync())
})

export default connect(null, mapDispatchToProps)(FormComponent)